import { Fragment, useEffect, useState } from "react";
import { useAuth } from "../../../../Context/AuthContext";
import { Link } from "react-router-dom";

export const ViewPdfButton = ({ item }) => {
  const { isAuthenticated } = useAuth();
  const baseDirectory = process.env.REACT_APP_publicUrl || window.location.origin;
  const [pdfHref, setPdfHref] = useState("");

  useEffect(() => {
    setPdfHref("/document/" + item.pdfPath);
  }, [item]);

  return (
    <Fragment>
      {item.pdfDisplay && (
        <div className="wesFlyerLink border-link">
          <Link to={pdfHref} target="_blank">
            <svg width={15} height={15} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_6545_66315)">
                <path
                  d="M7.99931 2.22396C6.18819 2.22396 4.69931 3.04618 3.55764 4.10451C2.48819 5.09896 1.74931 6.27951 1.37153 7.11285C1.74931 7.94618 2.48819 9.12674 3.55486 10.1212C4.69931 11.1795 6.18819 12.0017 7.99931 12.0017C9.81042 12.0017 11.2993 11.1795 12.441 10.1212C13.5104 9.12674 14.2493 7.94618 14.6271 7.11285C14.2493 6.27951 13.5104 5.09896 12.4438 4.10451C11.2993 3.04618 9.81042 2.22396 7.99931 2.22396ZM2.64931 3.12951C3.95764 1.91285 5.75486 0.890625 7.99931 0.890625C10.2438 0.890625 12.041 1.91285 13.3493 3.12951C14.6493 4.33785 15.5187 5.77951 15.9326 6.77118C16.0243 6.99063 16.0243 7.23507 15.9326 7.45451C15.5187 8.44618 14.6493 9.89063 13.3493 11.0962C12.041 12.3128 10.2438 13.3351 7.99931 13.3351C5.75486 13.3351 3.95764 12.3128 2.64931 11.0962C1.34931 9.89063 0.479861 8.44618 0.06875 7.45451C-0.0229167 7.23507 -0.0229167 6.99063 0.06875 6.77118C0.479861 5.77951 1.34931 4.33507 2.64931 3.12951ZM7.99931 9.33507C9.22708 9.33507 10.2215 8.34063 10.2215 7.11285C10.2215 5.88507 9.22708 4.89062 7.99931 4.89062C7.97986 4.89062 7.96319 4.89062 7.94375 4.89062C7.97986 5.03229 7.99931 5.18229 7.99931 5.33507C7.99931 6.31563 7.20208 7.11285 6.22153 7.11285C6.06875 7.11285 5.91875 7.0934 5.77708 7.05729C5.77708 7.07674 5.77708 7.0934 5.77708 7.11285C5.77708 8.34063 6.77153 9.33507 7.99931 9.33507ZM7.99931 3.55729C8.9423 3.55729 9.84667 3.93189 10.5135 4.59869C11.1803 5.26549 11.5549 6.16986 11.5549 7.11285C11.5549 8.05584 11.1803 8.96021 10.5135 9.627C9.84667 10.2938 8.9423 10.6684 7.99931 10.6684C7.05631 10.6684 6.15194 10.2938 5.48515 9.627C4.81835 8.96021 4.44375 8.05584 4.44375 7.11285C4.44375 6.16986 4.81835 5.26549 5.48515 4.59869C6.15194 3.93189 7.05631 3.55729 7.99931 3.55729Z"
                  fill="#333333"
                />
              </g>
              <defs>
                <clipPath id="clip0_6545_66315">
                  <rect width={16} height="14.2222" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span>
              <span className="wesFlyerView">View</span>PDF
            </span>
          </Link>
        </div>
      )}
    </Fragment>
  );
};
